import api from '../utils/api';

const disciplineService = {
  listIncidents: async (status) => {
    try {
      return await api.get('/api/discipline/incidents', { params: { status } });
    } catch (error) {
      console.error('Error fetching incidents:', error);
      throw error;
    }
  },
  createIncident: async (data) => {
    try {
      return await api.post('/api/discipline/incidents', data);
    } catch (error) {
      console.error('Error creating incident:', error);
      throw error;
    }
  },
  updateIncident: async (incidentId, data) => {
    try {
      return await api.put(`/api/discipline/incidents/${incidentId}`, data);
    } catch (error) {
      console.error('Error updating incident:', error);
      throw error;
    }
  },
  deleteIncident: async (incidentId) => {
    try {
      return await api.delete(`/api/discipline/incidents/${incidentId}`);
    } catch (error) {
      console.error('Error deleting incident:', error);
      throw error;
    }
  },
  createAction: async (incidentId, data) => {
    try {
      return await api.post(`/api/discipline/incidents/${incidentId}/actions`, data);
    } catch (error) {
      console.error('Error recording action:', error);
      throw error;
    }
  },
  listActions: async (incidentId) => {
    try {
      return await api.get(`/api/discipline/incidents/${incidentId}/actions`);
    } catch (error) {
      console.error('Error fetching actions:', error);
      throw error;
    }
  },
  getStudentTally: async (studentId, termId) => {
    try {
      return await api.get(`/api/discipline/students/${studentId}/tally`, { params: { term_id: termId } });
    } catch (error) {
      console.error('Error fetching demerit tally:', error);
      throw error;
    }
  },
  approveAction: async (actionId) => {
    try {
      return await api.post(`/api/discipline/actions/${actionId}/approve`);
    } catch (error) {
      console.error('Error approving action:', error);
      throw error;
    }
  },
  rejectAction: async (actionId, rejectionReason) => {
    try {
      return await api.post(`/api/discipline/actions/${actionId}/reject`, { rejection_reason: rejectionReason });
    } catch (error) {
      console.error('Error rejecting action:', error);
      throw error;
    }
  },
};

export default disciplineService;
